import { Deck } from "../searchEngine/types";
import { createDeck } from "../services";
import { editDeck } from "../services";

export const decksCollection = "decks"

export const saveDeck = (deck: Deck) => {
	if (deck.title.trim() === '' || deck.version.trim() === '' || deck.decklist.trim() === '')
		throw new Error('Deck without title, version or cards')

	if (deck.id)
		editDeck(deck)
	else
		createDeck(deck)
}

export const addChangeHistoryToDeck = (newDeck: Deck, previousVersion: Deck, timestamp: string) => {

	newDeck.changeHistory = previousVersion.changeHistory || []
	newDeck.changeHistory.push(timestamp)

	if (newDeck.version !== previousVersion.version)
		newDeck.changeHistory?.push('Version changed')
	if (newDeck.title !== previousVersion.title)
		newDeck.changeHistory?.push('Title changed')
	if (newDeck.description !== previousVersion.description)
		newDeck.changeHistory?.push('description changed')
	if (newDeck.decklist !== previousVersion.decklist)
		newDeck.changeHistory?.push("decklist\n" + checkCardlistDifferences(newDeck.decklist, previousVersion.decklist))
	if (newDeck.maybeboard !== previousVersion.maybeboard)
		newDeck.changeHistory?.push("maybeboard\n" + checkCardlistDifferences(newDeck.maybeboard, previousVersion.maybeboard))

	newDeck.changeHistory.push('-------------------')

	return newDeck.changeHistory
}

export const parseCardList = (cardList: string): { quantity: number, cardName: string }[] => {
	let cardLIstSplited = cardList.split('\n').filter(x => x)

	return cardLIstSplited.map(cardString => {
		const index = cardString.indexOf(' ');

		if (index !== -1) {
			const quantity = Number (cardString.slice(0, index));
			const cardName = cardString.slice(index + 1);

			return { quantity, cardName }
		} else throw new Error('Something went wrong with decklist parser')
	})
}

export const checkCardlistDifferences = (newDeck: string, previousVersion: string): string => {
	let diff = ''
	const newDeckParsed = parseCardList(newDeck)
	const previousVersionParsed = parseCardList(previousVersion)

	newDeckParsed.forEach(card => {
		const previousCard = previousVersionParsed.find(c => c.cardName === card.cardName)

		if (!previousCard) diff += `+${card.quantity}x ${card.cardName}\n`
		else if (previousCard.quantity < card.quantity)
			diff += `+${card.quantity - previousCard.quantity}x ${card.cardName}\n`
		else if (previousCard.quantity > card.quantity)
			diff += `-${previousCard.quantity - card.quantity}x ${card.cardName}\n`
	})

	previousVersionParsed.forEach(card => {
		const newCard = newDeckParsed.find(c => c.cardName === card.cardName)

		if (!newCard) diff += `-${card.quantity}x ${card.cardName}\n`
	})

	return diff
}